var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('type-sol-horizon',{ref:"typeSolHorizon1",attrs:{"horizon":1}}),_c('type-sol-horizon',{ref:"typeSolHorizon2",attrs:{"horizon":2}}),_c('type-sol-horizon',{ref:"typeSolHorizon3",attrs:{"horizon":3}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }